// extracted by mini-css-extract-plugin
export default {"tfaItem":"TwoFactorAuth_tfaItem__esHvD","tfaStep":"TwoFactorAuth_tfaStep__GC+y7","tfaInput":"TwoFactorAuth_tfaInput__sYBPE"};